import { Col, ConfigProvider, Form, Row } from "antd";
import React, { useEffect } from "react";
import Inputs from "../../../biblio/Inputs/Inputs";
import Selects from "../../../biblio/Selects/Selects";
import {
  getAllGovernorates,
  getAllIdentificationTypes,
  getAllNeighborhoodOnly,
} from "../../../apis/actions/recipient.actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import SecondaryButton from "../../../biblio/Buttons/SecondaryButton";
import HijriFeature from "../../../biblio/HijriFeature";
import dayjs from "dayjs";
import ar_EG from "antd/lib/locale/ar_EG";
import updateLocale from "dayjs/plugin/updateLocale";
import { toRegisterProgramExternalRequest } from "../../../apis/actions/programs.actions";
import { showNotitfication } from "../../../components/utils/utils";
import { useNavigate } from "react-router-dom";
import { setResIds, setResModel } from "../../../apis/slices/ratingSlice";
dayjs.extend(updateLocale);

dayjs.updateLocale("ar", {
  weekStart: 6,
  weekdays: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
});

interface RegistrationProgramCardProps {
  id: number;
}

const RegistrationProgramCard = ({ id }: RegistrationProgramCardProps) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { identificationTypes, neighborhoodsOnly } = useSelector(
    (state: RootState) => state.recipient
  );

  const { loading } = useSelector(
    (state: RootState) => state.programs.registerRequest
  );

  useEffect(() => {
    dispatch(getAllGovernorates());
    dispatch(getAllIdentificationTypes());
    dispatch(getAllNeighborhoodOnly());
  }, [dispatch]);

  const handleDateChange = (field: string) => (dateValue: any) => {
    form.setFieldsValue({
      [field]: dateValue,
    });
  };

  const handleSubmit = async () => {
    try {
      await form.validateFields();

      const values = form.getFieldsValue();
      const formattedDate = dayjs(values.birthday).format("YYYY-MM-DD");
      const gender = form.getFieldValue("gender");
      const mappedGender = gender.value === 1 ? "male" : "female";

      const registrationData = {
        ...values,
        program_id: id,
        birthday: formattedDate,
        gender: mappedGender,
        identification_type_id: form.getFieldValue("identification_type_id")
          ?.value,
        neighborhood_id: form.getFieldValue("neighborhood_id")?.value,
      };

      const success = (await dispatch(
        toRegisterProgramExternalRequest(registrationData)
      )) as any;
      const externalProgram = success?.payload?.result;
      if (externalProgram?.code === 200) {
        dispatch(setResIds([externalProgram?.application_id]));
        dispatch(setResModel(externalProgram?.res_model));
        showNotitfication(externalProgram?.message, "success", dispatch);
        setTimeout(() => {
          navigate("/programs");
        }, 3000);
      } else {
        showNotitfication(externalProgram?.message, "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="takaful--registration-program-card-container">
      <div className="takaful--registration-program-card-title">
        <span>الترشح للبرنامج</span>
      </div>
      <Form
        form={form}
        layout="vertical"
        className="takaful--registration-program-card-form"
      >
        <ConfigProvider locale={ar_EG} direction="rtl">
          <Row gutter={16}>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="firstname"
                label="الاسم الأول"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs />
              </Form.Item>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="father_name"
                label="إسم الأب"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs />
              </Form.Item>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="grandfather_name"
                label="إسم الجد"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs />
              </Form.Item>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="family_name"
                label="إسم العائلة"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs />
              </Form.Item>
            </Col>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item
                name="gender"
                label="الجنس"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Selects
                  options={[
                    { id: 1, name: "ذكر" },
                    { id: 2, name: "أنثى" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="mobile"
                label="رقم الجوال"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                  {
                    len: 10,
                    message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs placeholder="05XXXXXXXX" type="tel" maxLength={10} />
              </Form.Item>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="email"
                label="البريد الإلكتروني"
                labelCol={{ className: "takaful--label-style" }}
                rules={[
                  {
                    type: "email",
                    message:
                      "يجب  التأكد من أن البريد الإلكتروني مكتوب بشكل صحيح",
                  },
                ]}
              >
                <Inputs placeholder="email@example.com" type="email" />
              </Form.Item>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="identification_type_id"
                label="نوع الهوية"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Selects options={identificationTypes?.data} />
              </Form.Item>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="identification_number"
                label="رقم الهوية"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                  {
                    len: 10,
                    message: "يجب أن يتكون رقم الهوية من 10 ارقام",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="tel" maxLength={10} />
              </Form.Item>
            </Col>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item
                name="birthday"
                label="تاريخ الميلاد"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <HijriFeature
                  onChange={handleDateChange("birthday")}
                  maxDateGregorian={dayjs(new Date())}
                  maxDateHijri={dayjs(new Date()).toDate()}
                />
              </Form.Item>
            </Col>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item
                name="neighborhood_id"
                label="الحي"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Selects options={neighborhoodsOnly} />
              </Form.Item>
            </Col>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item
                name="address"
                label="العنوان"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs />
              </Form.Item>
            </Col>
          </Row>
        </ConfigProvider>

        <SecondaryButton
          className="takaful--registration-program-card-button"
          title="ترشح للبرنامج"
          onClick={handleSubmit}
          loading={loading}
          disabled={loading}
        />
      </Form>
    </div>
  );
};

export default RegistrationProgramCard;
